import { Trans, useLingui } from "@lingui/react/macro";
import { observer } from "mobx-react-lite";
import { useState } from "react";

import { AppModel } from "../../../app/app-model";
import { useSupportedMedicalData } from "../../../catalogs/supported-medical-data";
import { AddTable } from "../../../components/ui-kit/tables/add-table";
import { CellCombobox } from "../../../components/ui-kit/tables/cell-fields/cell-combobox";
import { CellDateInput } from "../../../components/ui-kit/tables/cell-fields/cell-date-input";
import { CellTextInput } from "../../../components/ui-kit/tables/cell-fields/cell-text-input";
import { CellRemoveButton } from "../../../components/ui-kit/tables/cells/cell-remove-button";
import {
  getNamesValues,
  getPrimaryUnitByName,
  getVariableByName,
} from "../../../utils/data-utils";
import { CellGenericValueField } from "../common/cell-generic-value-field";
import { AddAnyData } from "./add-any-data";

export const AddAnyDataTable = observer(function AddAnyDataTable(props: {
  app: AppModel;
}) {
  const { t } = useLingui();
  const patient = props.app.requirePatient();
  const supportedMedData = useSupportedMedicalData();
  const [model] = useState(() => {
    const m = new AddAnyData(patient.api, patient);
    void m.initEmpty();
    return m;
  });

  return (
    <AddTable
      columns={[
        {
          header: <Trans>Measured at</Trans>,
          mandatory: true,
          cell: (item) => (
            <CellDateInput
              attr="measurement_datetime"
              model={item}
              type="datetime-local"
            />
          ),
        },
        {
          header: <Trans>Measurement type</Trans>,
          mandatory: true,
          cell: (item) => (
            <CellCombobox
              attr="measurement_type"
              model={item}
              values={getNamesValues(supportedMedData)}
              listTitle={t`Select data to add`}
            />
          ),
        },
        {
          header: <Trans>Measurement value</Trans>,
          mandatory: true,
          cell: (item) => (
            <CellGenericValueField
              model={item}
              attr="measurement_value"
              variableDef={getVariableByName(
                model.supportedVariables,
                item.measurement_type,
              )}
            />
          ),
        },
        {
          header: <Trans>Measurement unit</Trans>,
          cell: (item) =>
            getPrimaryUnitByName(supportedMedData, item.measurement_type),
        },
        {
          header: <Trans>Comment</Trans>,
          cell: (item) => (
            <CellTextInput attr="comment" model={item} multiline="autosize" />
          ),
        },
        {
          header: <Trans>Remove data row</Trans>,
          cell: (item, index) => (
            <CellRemoveButton index={index} model={model} />
          ),
        },
      ]}
      model={model}
      canAddRows
      setAllDates="datetime"
    />
  );
});
